/* TUYYA — ajout au panier depuis les cartes du Journal (19/10/2026).
   Envoie le formulaire en AJAX (/cart/add.js), affiche « Ajouté — voir le panier »,
   et prévient le thème (pubsub Wokiee cartUpdate) pour rafraîchir le compteur. */
(function () {
  if (window.__tuyyaQuickAdd) return; window.__tuyyaQuickAdd = true;
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-tuyya-quickadd]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('.tuyya-pieces__add');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(f.getAttribute('action') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(f)
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        var a = document.createElement('a');
        a.className = 'tuyya-pieces__add tuyya-pieces__add--done';
        a.href = f.dataset.cart; a.textContent = f.dataset.added + ' →';
        if (btn) btn.replaceWith(a);
        try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tuyya-quickadd' }); } catch (x) {}
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
        }).catch(function () {});
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = f.dataset.error; }
      });
  });
})();

/* Rangées défilantes : flèches visibles seulement si la rangée déborde ; état début/fin. */
(function () {
  function sync(aside) {
    var t = aside.querySelector('.tuyya-pieces__track'), nav = aside.querySelector('.tuyya-pieces__nav');
    if (!t || !nav) return;
    var over = t.scrollWidth > t.clientWidth + 4;
    nav.hidden = !over;
    var b = nav.querySelectorAll('[data-tuyya-scroll]');
    if (b.length === 2) { b[0].disabled = t.scrollLeft <= 2; b[1].disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2; }
  }
  function init() {
    document.querySelectorAll('.tuyya-pieces--scroll').forEach(function (a) {
      if (a.__tuyyaNav) return; a.__tuyyaNav = true;
      var t = a.querySelector('.tuyya-pieces__track');
      if (t) t.addEventListener('scroll', function () { sync(a); }, { passive: true });
      sync(a);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tuyya-scroll]');
    if (!btn) return;
    var a = btn.closest('.tuyya-pieces'), t = a && a.querySelector('.tuyya-pieces__track');
    if (!t) return;
    var card = t.querySelector('.tuyya-pieces__card');
    var step = card ? card.getBoundingClientRect().width + 20 : t.clientWidth * 0.8;
    t.scrollBy({ left: step * parseInt(btn.getAttribute('data-tuyya-scroll'), 10), behavior: 'smooth' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', function () { document.querySelectorAll('.tuyya-pieces--scroll').forEach(sync); });
  window.addEventListener('load', function () { document.querySelectorAll('.tuyya-pieces--scroll').forEach(sync); });
})();